/* tslint:disable:align */
//============================================================================
// Name        : BulkAdd.tsx
// Purpose     : Implement Bulk Add tags
// Created     : 2020-05-14
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line: no-unused-expression
/** @jsx jsx */ jsx;
import { css, jsx } from "@emotion/core";
import axios from "axios";
import React from "react";
import Alert from "react-bootstrap/Alert"
import Select from "react-select";
import * as GlobalSettings from "../globalSettings";

const qtyStyle = css`
    width: 60px;
    display: inline;
    margin-right: 15px;
`;

interface IZone {
    id: number;
    name: string;
}

interface IMarkerTag {
    name: string;
    serial: string;
    epc: string;
    zoneId: number;
    antenna: string;
}

interface IBulkAddProps {
    redirectUrl: string;
    saveUrl: string;
    tagInfoUrl: string;
    zones: IZone[];
}

interface IBulkAddState {
    tagList: IMarkerTag[];
    tagQty: string;
    show: boolean;
    errors: string[];
}

export default class BulkAdd extends React.Component<IBulkAddProps, IBulkAddState> {
    constructor(props: any) {
        super(props);

        // Set state from props
        // this.state = this.props;
        this.state = {
            tagList: [{
                name:    "",
                serial:  "",
                epc:     "",
                zoneId:  -1,
                antenna: ""
            }],
            errors: [],
            tagQty:  "1",
            show: false
        };
    }

    onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newState: Partial<IBulkAddState> = { [event.target.name]: event.target.value };
        this.setState(newState as IBulkAddState);
    }

    onChangeTag = (key: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const tagList = this.state.tagList;
        const tag     = tagList[key];

        tag[event.target.name] = event.target.value;
        tagList[key]           = tag;
        this.setState({ tagList });
    }

    onKeyUpTag(key: number, _event: React.KeyboardEvent) {
        const tag = this.state.tagList[key];
        const firstEpc  = $(".epc_input").val().toString();

        this.getTagInfo(key, tag.serial, firstEpc);
    }

    onZoneChange(key: number, event: any) {
        const tagList = this.state.tagList;
        const tag     = tagList[key];

        tag.zoneId   = event.value;
        tagList[key] = tag;
        this.setState({ tagList });
    }

    zoneToValue(value: number) {
        if (value == -1) {
            return null;
        }
        const zone = this.props.zones.filter(x => x.id == value)[0];
        return { value, label: zone.name };
    }

    onRemoveTag = (key: number, _event: any) => {
        const tagList = this.state.tagList;
        tagList.splice(key, 1);
        this.setState({ tagList });
    }

    onAddTags = () => {
        const tagList        = this.state.tagList;
        const tagQty: number = Number(this.state.tagQty);

        const lastNameIdx   = Number(tagList[tagList.length - 1].name) + 1;
        const lastSerialIdx = Number(tagList[tagList.length - 1].serial) + 1;
        const defaultZoneId = tagList[0].zoneId;

        for (let i = 0; i < tagQty; i++) {
            tagList.push({
                name:    (lastNameIdx + i).toFixed(),
                serial:  (lastSerialIdx + i).toFixed(),
                epc:     "",
                zoneId:  defaultZoneId,
                antenna: (lastNameIdx + i).toFixed() + "01"
            } as IMarkerTag);
        }
        this.setState({ tagList });
        this.getAllTagsInfo();
    }

    getTagInfo = async (key: number, assetId: string, epcStartWith: string) => {
        const res = await axios.get(this.props.tagInfoUrl, { params: { assetId, epcStartWith }});
        if (res.status != 200) {
            console.error(`Error fetching tag info for Asset ID: ${assetId}`);
            return;
        }

        const tagList = this.state.tagList;
        const tag     = tagList[key];

        tag.epc      = res.data?.epc_id;
        tagList[key] = tag;
        this.setState({ tagList });
    }

    async getAllTagsInfo() {
        const firstEpc  = $(".epc_input").val().toString();

        for (let i = 0; i < this.state.tagList.length; i++) {
            const tag       = this.state.tagList[i];

            await this.getTagInfo(i, tag.serial, firstEpc);
        }
    }

    onSaveBulkAdd = async () => {
        const errors = this.validate();
        if (errors.length) {
            this.setState({ show: true });
        }
        if (errors.length == 0) {
            const resp = await axios.post(this.props.saveUrl, { tagList: this.state.tagList });
            if (resp.status != 200) {
                alert("Error saving list of tags.");
                return;
            }
            location.href = this.props.redirectUrl;
        }
    }

    validate = () => {
        const errors = [];
        this.state.tagList.map((row, index) => {
            if (row.antenna == "") {
                errors.push({ row: index, column: "antenna" });
            }
            if (row.epc == "") {
                errors.push({ row: index, column: "epc" });
            }
            if (row.name == "") {
                errors.push({ row: index, column: "name" });
            }
            if (row.serial == "") {
                errors.push({ row: index, column: "serial" });
            }
            if (row.zoneId == -1) {
                errors.push({ row: index, column: "zoneId" });
            }
            this.setState({ errors });
        });
        return errors;
    }

    render() {
        const zones = [];
        for (const z of this.props.zones) {
            zones.push({ value: z.id, label: z.name });
        }
        return (
            <React.Fragment>
                {
                    this.state.errors.length > 0 && (
                        <Alert variant="danger" show={this.state.show} transition={false}>
                            <p style={{color: "black"}}>Please fill the blank fields</p>
                        </Alert>
                    )
                }
                <div className="row">
                    <div className="table-responsive col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <table className="table table-bordered table-striped">
                            <thead className="thead-inverse">
                                <tr>
                                    <th>Name</th>
                                    <th>Serial</th>
                                    <th>EPC</th>
                                    <th>Zone</th>
                                    <th>Antenna</th>
                                    <th> </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.tagList.map((tag, key) =>
                                    <tr key={key}>
                                       <td><input type="text" value={tag.name}   name="name"   onChange={(e) => this.onChangeTag(key, e)} className="form-control" /></td>
                                       <td><input type="text" value={tag.serial} name="serial" onChange={(e) => this.onChangeTag(key, e)} onKeyUp={(e) => this.onKeyUpTag(key, e)} className="form-control" /></td>
                                       <td><input type="text" value={tag.epc}    name="epc"    onChange={(e) => this.onChangeTag(key, e)} className="form-control epc_input" /></td>
                                       <td>
                                           <div css={{ width: "100%" }}>
                                               <Select placeholder="Select Location..." css={{ minWidth: 180 }}
                                                       options={zones} styles={GlobalSettings.selectCustomStyle}
                                                       onChange={this.onZoneChange.bind(this, key)}
                                                       value={this.zoneToValue(tag.zoneId)}
                                                       menuPortalTarget={document.querySelector("body")} />
                                           </div>
                                        </td>
                                       <td><input type="text" value={tag.antenna} name="antenna" onChange={(e) => this.onChangeTag(key, e)} className="form-control" /></td>
                                       <td>
                                           <button type="button" onClick={this.onRemoveTag.bind(this, key)} className="btn btn-red-small">Remove</button>
                                        </td>
                                    </tr>
                                )}
                           </tbody>
                        </table>
                    </div>
                </div>

                <div className="form-group">
                    <input type="number" name="tagQty" value={this.state.tagQty} onChange={this.onChange} className="form-control" css={qtyStyle} />
                    <button type="button" onClick={this.onAddTags} className="btn btn-green-small">Add Tags</button>
                    <button type="button" onClick={this.onSaveBulkAdd} className="btn btn-blue-large mng_left10px">Save Bulk Add</button>
                </div>
            </React.Fragment>
        );
    }
}
